import {Modal} from 'react-bootstrap'

import styles from './NotificationModal.css'

export default class NotificationModal extends React.Component {
  render () {
    const {isShow, headerMessage, bodyMessage, btnConfirm, btnHide, onHide, onConfirm, isNotificationError} = this.props
    return (<Modal show={isShow} onHide={this._onHide} dialogClassName={`modal-dialog ${styles.dialog}`}>
      <Modal.Header bsClass={isNotificationError !== 'success' ? `modal-header ${styles.error}` : `modal-header ${styles.notification}`}>
        <div className='title'>
          {headerMessage}
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>{bodyMessage}</p>
      </Modal.Body>
      <Modal.Footer>
        {isNotificationError !== 'success' && <button onClick={() => onHide()} className='btn btn-default'>{btnHide}</button> }
        {isNotificationError !== 'success' && <button onClick={() => onConfirm()} className='btn btn-primary'>{isNotificationError !== 'unregistered' ? btnConfirm : 'Sign Up'}</button> }
        {isNotificationError === 'success' && <button onClick={() => onConfirm()} className='btn btn-default'>Ok</button> }
      </Modal.Footer>
    </Modal>)
  }
}



// WEBPACK FOOTER //
// ./app/pages/ResendVerificationEmail/NotificationModal/NotificationModal.js